"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportBlockedValueEventsCsv = exports.exportBlockedValueSummaryCsv = exports.blockedValueSummary = exports.getWeeklyTip = exports.sendTestDigest = exports.recalculateOrderCost = exports.debugAnalyticsBenchmark = exports.computeAnalyticsBenchmark = exports.getAnalyticsBenchmark = exports.getCostSyncStatus = exports.getAnalyticsCumulativeRevenue = exports.getShippingRoi = exports.analyticsControllerGetCampaignPerformance = exports.getAnalyticsBasketStats = exports.getAnalyticsCharts = exports.getAnalyticsDailySeries = exports.getAnalyticsOrders = void 0;
const fetchInstance_1 = require("../../../utils/fetchInstance");
/**
* @summary Get paginated orders with campaign breakdown and summary stats
*/
const getAnalyticsOrders = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/analytics/orders`, method: 'get',
        params
    });
};
exports.getAnalyticsOrders = getAnalyticsOrders;
/**
* @summary Daily revenue series for the revenue-lift chart
*/
const getAnalyticsDailySeries = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/analytics/daily`, method: 'get',
        params
    });
};
exports.getAnalyticsDailySeries = getAnalyticsDailySeries;
/**
* @summary Top campaigns and revenue by type for dashboard charts
*/
const getAnalyticsCharts = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/analytics/charts`, method: 'get',
        params
    });
};
exports.getAnalyticsCharts = getAnalyticsCharts;
/**
* @summary Avg basket size (campaign vs baseline) for the overview strip
*/
const getAnalyticsBasketStats = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/analytics/basket-stats`, method: 'get',
        params
    });
};
exports.getAnalyticsBasketStats = getAnalyticsBasketStats;
const analyticsControllerGetCampaignPerformance = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/analytics/campaign-performance`, method: 'get',
        params
    });
};
exports.analyticsControllerGetCampaignPerformance = analyticsControllerGetCampaignPerformance;
/**
* @summary Shipping promotion ROI using incremental cart-bump attribution
*/
const getShippingRoi = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/analytics/shipping-roi`, method: 'get'
    });
};
exports.getShippingRoi = getShippingRoi;
/**
* @summary All-time cumulative revenue (for milestones)
*/
const getAnalyticsCumulativeRevenue = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/analytics/cumulative`, method: 'get'
    });
};
exports.getAnalyticsCumulativeRevenue = getAnalyticsCumulativeRevenue;
/**
* @summary Timestamp of the most recent variant cost sync
*/
const getCostSyncStatus = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/analytics/cost-sync-status`, method: 'get'
    });
};
exports.getCostSyncStatus = getCostSyncStatus;
/**
* @summary Peer benchmark: shop AOV uplift percentile vs all shops
*/
const getAnalyticsBenchmark = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/analytics/benchmark`, method: 'get'
    });
};
exports.getAnalyticsBenchmark = getAnalyticsBenchmark;
/**
* @summary Trigger benchmark snapshot computation and return result
*/
const computeAnalyticsBenchmark = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/analytics/benchmark/compute`, method: 'get'
    });
};
exports.computeAnalyticsBenchmark = computeAnalyticsBenchmark;
/**
* @summary Debug: show raw order counts and snapshot state for this shop
*/
const debugAnalyticsBenchmark = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/analytics/benchmark/debug`, method: 'get'
    });
};
exports.debugAnalyticsBenchmark = debugAnalyticsBenchmark;
/**
* @summary Fetch latest cost-per-item from Shopify for every variant in this order, upsert variantCost, recompute order totals, and return the refreshed order
*/
const recalculateOrderCost = (orderId) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/analytics/orders/${orderId}/recalculate-cost`, method: 'post'
    });
};
exports.recalculateOrderCost = recalculateOrderCost;
/**
* @summary Send a test weekly digest email to the shop recipient
*/
const sendTestDigest = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/analytics/send-test-digest`, method: 'post'
    });
};
exports.sendTestDigest = sendTestDigest;
/**
* @summary Get a personalised weekly tip based on campaign gaps and AOV
*/
const getWeeklyTip = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/analytics/weekly-tip`, method: 'get'
    });
};
exports.getWeeklyTip = getWeeklyTip;
/**
* @summary Pro feature D — blocked cart value tiles, daily series, per-rule table
*/
const blockedValueSummary = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/analytics/blocked-value/summary`, method: 'get',
        params
    });
};
exports.blockedValueSummary = blockedValueSummary;
/**
* @summary Pro feature D — CSV export of the per-rule/per-day summary
*/
const exportBlockedValueSummaryCsv = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/analytics/blocked-value/export/summary`, method: 'get',
        params
    });
};
exports.exportBlockedValueSummaryCsv = exportBlockedValueSummaryCsv;
/**
* @summary Pro feature D — CSV export of raw blocked-attempt events, streamed, 90-day cap
*/
const exportBlockedValueEventsCsv = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/analytics/blocked-value/export/events`, method: 'get',
        params
    });
};
exports.exportBlockedValueEventsCsv = exportBlockedValueEventsCsv;
